import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Benefits } from "./components/Benefits";
import { HowItWorks } from "./components/HowItWorks";
import { ForClinicsCTA } from "./components/ForClinicsCTA";
import { Footer } from "./components/Footer";
import { HelpPanel } from "@/shared/help/components/HelpPanel";
import { useTranslation } from "react-i18next";
import { PublicSeo } from "../components/PublicSeo";

export function PatientLandingPage() {
  const { t } = useTranslation(["landing"]);

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-background text-foreground custom-scrollbar">
      <PublicSeo
        title={t("landing:seo.patient_home_title")}
        description={t("landing:seo.patient_home_description")}
        path="/info-patients"
      />
      <Header />
      {/* Contenedor horizontal como en Tenant */}
      <div className="flex flex-1 min-h-0 relative overflow-hidden">
        {/* Contenido público */}
        <main className="flex-1 overflow-y-auto">
          <Hero />
          <Benefits />
          <HowItWorks />
          <ForClinicsCTA />
          <Footer />
        </main>
        <HelpPanel contextScope="PUBLIC_PATIENT" />
      </div>
    </div>
  );
}

